import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import Timer from 'js/unibrows/seasonal_discount_unibrow/Timer';
import { currentUser } from 'js/utils/user';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _Button from "NewUserDiscountButton-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/NewUserDiscountButton.tsx?styleId=Button";
import _ButtonText from "NewUserDiscountButton-ButtonText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/NewUserDiscountButton.tsx?styleId=ButtonText";


type NewUserDiscountButtonProps = {
  feature: string;
  trigger: string;
  couponCode: string;
};

const Button = /*#__PURE__*/styled("div", null, {
  displayName: "Button",
  styles: _Button
});

const ButtonText = /*#__PURE__*/styled("span", null, {
  displayName: "ButtonText",
  styles: _ButtonText
});

const NewUserDiscountButton = ({
  feature,
  trigger,
  couponCode,
}: NewUserDiscountButtonProps) => {
  if (currentUser?.created_at === undefined) {
    return null;
  }

  const checkoutUrl = routes.checkout_url({
    feature,
    trigger,
    coupon_code: couponCode,
  });

  const promotionEnd = Date.parse(currentUser.created_at) + 24 * 60 * 60 * 1000;
  const startDuration = Math.floor((promotionEnd - Date.now()) / 1000);

  return (
    <ImpressionWatcher source={trigger}>
      <Button as={'a'} href={checkoutUrl}>
        <ButtonText blue>UPGRADE & GET 6 MONTHS FREE!</ButtonText>
        <Timer
          darkIndicator
          startDuration={startDuration}
          mini={true}
          style={{ paddingTop: 0 }}
        />
      </Button>
    </ImpressionWatcher>
  );
};

export default NewUserDiscountButton;
